import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const tdStyle: any = {
    0: {
        align: 'left',
        width: '572px',
    },
    1: {
        align: 'center',
        width: '306px',
    },
    2: {
        align: 'center',
        width: '306px',
    },
};

export default function H() {
    const { useLang } = useGlobal();
    const { t } = useLang('poweroceanapp');

    const tableData = {
        columns: ['', t('sec8_th1'), t('sec8_th2')],
        rows: [
            [t('sec8_row1'), t('sec8_y'), t('sec8_y')],
            [t('sec8_row2'), t('sec8_y'), t('sec8_y')],
            [t('sec8_row3'), t('sec8_y'), ''],
            [t('sec8_row4'), t('sec8_y'), ''],
            [t('sec8_row5'), t('sec8_y'), ''],
            [t('sec8_row6'), t('sec8_y'), ''],
            [t('sec8_row7'), t('sec8_y'), t('sec8_y')],
            [t('sec8_row8'), t('sec8_y'), ''],
            [t('sec8_row9'), t('sec8_y'), t('sec8_y')],
            [t('sec8_row10'), t('sec8_y'), t('sec8_y')],
            [t('sec8_row11'), t('sec8_y'), ''],
            [t('sec8_row12'), t('sec8_y'), t('sec8_y')],
            [t('sec8_row13'), '', t('sec8_y')],
            // [t('sec8_row14'), '', t('sec8_y')],
        ],
    };

    return (
        <div className={`ef-app-pc-h ${css.efAppPCH}`}>
            <div className="text-wrapper">
                <p className="sub-title">{t('sec8_subtitle')}</p>
                <p className="title">{t('sec8_title')}</p>
                <table className="ef-app-table">
                    <thead>
                        <tr className="table-head">
                            {tableData.columns.map((th, i) => (
                                <th key={i}>{th}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.rows.map((tr, i) => (
                            <tr className="table-row" key={i}>
                                {tr.map((td, t) => (
                                    <td align={tdStyle[t].align} width={tdStyle[t].width} key={t}>
                                        {td}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
